import { Component, ElementRef, EventEmitter, HostListener, Inject, Input, NgZone, OnInit, Output, Renderer2, ViewChild } from '@angular/core';
import { HeaderService } from 'src/providers/header.service';
import { LoginModal } from '../header/header.component';
import { DOCUMENT } from '@angular/common';
import { DeviceDetectorService } from 'ngx-device-detector';
import { LoginService } from 'src/providers/login.service';
import { LOCAL_STORAGE } from '@ng-toolkit/universal';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AuthService } from 'src/providers/auth.service';

declare var $: any;

@Component({
  selector: 'app-header',
  templateUrl: './top-bar.component.html',
  styleUrls: ['./top-bar.component.scss']
})
export class TopBarComponent implements OnInit {
  @Input('pageType') pageType: any;
  @Input('number') phoneNo: any;
  @Input('pageUrl') pageUrl: any;

  errorMsg:any;
  otpFlag:boolean = false;
  @Output() change = new EventEmitter<string>()
  @Output() changeCourse = new EventEmitter<string>()
  @Output() onLogin = new EventEmitter<string>()
  @Input('url') url: any;
  menuItemsList: any = {
    '1': {
      courses: [
        { name: 'CAT Full Course + IIM ABC', link: '/details/cat-2025-full-course-iim-abc-practice-batch', linktext: 'cat-2025-full-course-iim-abc-practice-batch' },
        { name: 'CAT 2025 Full Course', link: '/details/cat-full-course', linktext: 'cat-full-course' },
        { name: 'CAT 2025 Full Course Pro', link: '/details/CAT-2025-full-course-pro', linktext: 'CAT-2025-full-course-pro' },
        { name: 'Maha MBA 2025 Course', link: '/details/maha-mba-2025-course', linktext: 'maha-mba-2025-course' },
        { name: 'CAT 2025 Full Course and Books', link: '/details/cat-2025-full-course-and-books', linktext: 'cat-2025-full-course-and-books' },
      ],
      practice: [
        { name: 'CAT Crash Course', link: '/cat-crash-course', linktext: '' },
        { name: 'CAT Books by iQuanta', link: '/best-cat-books', linktext: '' },
        { name: 'iCAT Mocks - 35 Full & 45 Sectionals', link: '/details/icat-mock-test-series', linktext: 'icat-mock-test-series' },
        { name: 'IIM ABC Practice Batch 2024', link: '/details/iim-abc-practice-batch-2024', linktext: 'iim-abc-practice-batch-2024' },
      ],
      importantLinks: [
        { name: 'CAT 2025 Early Start Plan', link: '/cat-2025', linktext: 'cat-2025' },
        { name: 'CAT Past Papers as Mocks', link: '/cat-mock-test', linktext: 'cat-mock-test' },
        { name: 'Free CAT Study material', link: '/test/free-cat-study-material', linktext: '' },
      ]
    },

    '2': {
      courses: [
        { name: 'All Non CAT Course', link: '/details/all-non-cat-course-2025', linktext: 'all-non-cat-course-2025' },
        { name: 'NMAT-SNAP Course', link: '/details/nmat-snap-course', linktext: 'nmat-snap-course' },
        { name: 'XAT Course', link: '/xat-coaching', linktext: '' },
        { name: 'CAT + NMAT + SNAP Course', link: '/details/cat-nmat-snap-full-course', linktext: 'cat-nmat-snap-full-course' },
        { name: 'MICAT Course', link: '/details/micat-course-2025', linktext: 'micat-course-2025' },
        { name: 'Maha MBA 2024 Course', link: '/details/all-non-cat-course-2025', linktext: 'all-non-cat-course-2025' },
      ],
      practice: [
        { name: 'NMAT Mocks 2025', link: '/details/nmat-mock-series', linktext: 'nmat-mock-series' },
        { name: 'SNAP Mocks 2025', link: '/details/snap-mock-series', linktext: 'snap-mock-series' },
        { name: 'XAT Mocks 2025', link: '/details/xat-mocks', linktext: 'xat-mocks' },
        { name: 'Non CAT Mocks', link: '/mba', linktext: '' },
      ],
      importantLinks: [
        { name: 'NMAT Roadmap', link: '/nmat-online-coaching', linktext: '' },
        { name: 'SNAP Roadmap', link: '/snap-online-coaching', linktext: '' },
        { name: 'XAT Roadmap', link: '/xat-coaching', linktext: '' },
      ]
    },

    '3': {
      courses: [
        // { name: 'IPMAT 2025 Full Course', link: '/details/ipmat-2025-course', linktext: 'ipmat-2025-course' },
        { name: 'IPMAT 2026 Full Course', link: '/details/ipmat-2026-course', linktext: 'ipmat-2026-course' },
        { name: 'IPMAT 2025 Full Course + Books', link: '/details/ipmat-course-and-ipmat-books', linktext: 'ipmat-course-and-ipmat-books' },
        { name: 'IPMAT 2026 Full Course + Books', link: '/details/ipmat-2026-course-and-ipmat-books', linktext: 'ipmat-2026-course-and-ipmat-books' },
        { name: 'CUET + IPMAT 2025 Full Course', link: '/details/cuet-ipmat-full-course', linktext: 'cuet-ipmat-full-course' },
      ],
      practice: [
        { name: 'IPMAT Mocks', link: '/ipmat-mock-test', linktext: '' },
        { name: 'IPMAT Books by iQuanta', link: '/best-ipmat-books', linktext: '' },
        { name: 'IPMAT Free All-India Mock', link: '/ipmat-mock-test', linktext: '' },
      ],
      importantLinks: [

      ]
    },

    '4': {
      courses: [
        { name: 'CUET UG Course', link: '/details/cuet-ug-recorded-course', linktext: 'cuet-ug-recorded-course' },
        { name: 'Boards + CUET 2025 Commerce', link: '/details/cuet-commerce-2025', linktext: 'cuet-commerce-2025' },
        { name: 'Boards + CUET 2025 Humanities', link: '/details/cuet-2025-humanities', linktext: 'cuet-2025-humanities' },
        { name: 'CUET + IPMAT 2025 Full Course', link: '/details/cuet-ipmat-full-course', linktext: 'cuet-ipmat-full-course' },
        { name: 'Boards + CUET 2026 Commerce', link: '/cuet', linktext: '' },
      ],
      practice: [

      ],
      importantLinks: [

      ]
    },

    '5': {
      courses: [
        { name: 'CLAT UG 2026 Crash Course', link: '/details/clat-crash-course', linktext: 'clat-crash-course' },
        { name: 'CLAT UG 2026 Full Course', link: '/details/clat-ug-2026-full-course', linktext: 'clat-ug-2026-full-course' },
      ],
      practice: [
        { name: 'CLAT UG 2026 Mocks', link: '/details/clat-test-series', linktext: 'clat-test-series' },
        { name: 'CLAT Books by iQuanta', link: '/details/iquanta-clat-books', linktext: 'iquanta-clat-books' },
        { name: 'CLAT Legal Mixed Practice Bank', link: '/details/CLAT-Legal-Reasoning-Practice-Material', linktext: 'CLAT-Legal-Reasoning-Practice-Material' },
      ],
      importantLinks: [

      ]
    },

    '6': {
      courses: [
        { name: 'GMAT FOCUS EDITION (3 Months)', link: '/details/gmat-full-course', linktext: 'gmat-full-course' },
        { name: 'GMAT FOCUS EDITION (6 Months)', link: '/details/gmat-full-course-6-months', linktext: 'gmat-full-course-6-months' },
        { name: 'IELTS Complete Training', link: '/details/ielts-course-1-month', linktext: 'ielts-course-1-month' },

      ],
      practice: [

      ],
      importantLinks: [

      ]
    },

    '7': {
      courses: [
        { name: 'IIT JEE Full Course', link: '/details/iit-jee-full-course-2026', linktext: 'iit-jee-full-course-2026' },
        { name: 'BITSAT Crash Course', link: '/bitsat-crash-course', linktext: '' },
        { name: 'JEE Crash Course', link: '/jee-crash-course', linktext: '' },

      ],
      practice: [

      ],
      importantLinks: [

      ]
    },

    '8': {
      courses: [
        { name: 'NEET 2026 Live Crash Course', link: '/details/neet-live-crash-course', linktext: 'neet-live-crash-course' },
        { name: 'NEET Full Course', link: '/details/neet-full-course-2026', linktext: 'neet-full-course-2026' },
        { name: 'NEET Dropper Batch', link: '/details/neet-dropper-batch-2026', linktext: 'neet-dropper-batch-2026' },

      ],
      practice: [

      ],
      importantLinks: [

      ]
    },


    'iDesign': {
      courses: [
        { name: 'UCEED Online Coaching', link: '/idesign/uceed', },
        { name: 'CEED Online Coaching', link: '/idesign/ceed', },
        { name: 'NID Online Coaching', link: '/idesign/nid', },
        { name: 'B.arch Online Coaching', link: '/idesign/barch', },
        { name: 'NIFT Online Coaching', link: '/idesign/nift', },
      ],
    }

  }

  allCoursesList: any =
    {
      '1': [
        { name: 'CAT 2025 All Packages', link: '/cat-2025', bgimg: 'https://media.iquanta.in/ui_images/menu-item-bg-01.webp', secondImg: 'https://media.iquanta.in/ui_images/king-icon.svg' },
        // {name: 'CAT Crash Course', link:'/cat-crash-course', bgimg: 'https://media.iquanta.in/ui_images/menu-item-bg-02.webp', secondImg: 'https://media.iquanta.in/ui_images/king-icon.svg'},
        { name: 'CAT AI Mocks', link: '/cat-mock-test', bgimg: 'https://media.iquanta.in/ui_images/menu-item-bg-02.webp', secondImg: 'https://media.iquanta.in/ui_images/king-icon.svg' },
        { name: 'CAT Books', link: '/best-cat-books', bgimg: 'https://media.iquanta.in/ui_images/menu-item-bg-03.webp', secondImg: '' }
      ],
      '2': [
        { name: 'XAT 2025 All Packages', link: '/xat-coaching', bgimg: 'https://media.iquanta.in/ui_images/menu-item-bg-01.webp', secondImg: 'https://media.iquanta.in/ui_images/king-icon.svg' },
        { name: 'NMAT 2025 All Packages', link: '/nmat-online-coaching', bgimg: 'https://media.iquanta.in/ui_images/menu-item-bg-02.webp', secondImg: 'https://media.iquanta.in/ui_images/king-icon.svg' },
        { name: 'SNAP 2025 All Packages', link: '/snap-online-coaching', bgimg: 'https://media.iquanta.in/ui_images/menu-item-bg-01.webp', secondImg: 'https://media.iquanta.in/ui_images/king-icon.svg' },
      ],
      '3': [
        { name: 'IPMAT All Packages', link: '/ipmat', bgimg: 'https://media.iquanta.in/ui_images/menu-item-bg-01.webp', secondImg: 'https://media.iquanta.in/ui_images/king-icon.svg' },
      ],
      '4': [
        { name: 'CUET All Packages', link: '/cuet', bgimg: 'https://media.iquanta.in/ui_images/menu-item-bg-01.webp', secondImg: 'https://media.iquanta.in/ui_images/king-icon.svg' },
      ],
      '5': [
        { name: 'CLAT All Packages', link: '/clat-coaching', bgimg: 'https://media.iquanta.in/ui_images/menu-item-bg-01.webp', secondImg: 'https://media.iquanta.in/ui_images/king-icon.svg' },
      ],
      '6': [
        { name: 'GMAT All Packages', link: '/gmat', bgimg: 'https://media.iquanta.in/ui_images/menu-item-bg-01.webp', secondImg: 'https://media.iquanta.in/ui_images/king-icon.svg' },
        { name: 'IELTS All Packagess', link: '/ielts', bgimg: 'https://media.iquanta.in/ui_images/menu-item-bg-02.webp', secondImg: 'https://media.iquanta.in/ui_images/king-icon.svg' },

      ],
      '7': [
        { name: 'IIT All Packages', link: '/iit-jee-coaching', bgimg: 'https://media.iquanta.in/ui_images/menu-item-bg-01.webp', secondImg: 'https://media.iquanta.in/ui_images/king-icon.svg' },
      ],
      '8': [
        { name: 'NEET All Packages', link: '/neet-coaching', bgimg: 'https://media.iquanta.in/ui_images/menu-item-bg-01.webp', secondImg: 'https://media.iquanta.in/ui_images/king-icon.svg' },
      ],
    }

  resultsTabData: any = {
    '1':
    {
      header: '700+ 99%ilers & 1000s of CAT Toppers', para: '25,000 IIM calls in just 5 years', bgimg: 'https://media.iquanta.in/ui_images/result-bg-menu.svg',
      alt: 'CAT Toppers', toppersImgs: [
        { img: 'https://media.iquanta.in/ui_images/cat2019/rishi1.webp', percentage: 'CAT 100%ile', alt: 'OMET Toppers' },
        { img: 'https://media.iquanta.in/ui_images/cat2017/gaurav1.webp', percentage: 'CAT 99.90%ile', alt: 'OMET Toppers' },
        { img: 'https://media.iquanta.in/ui_images/cat2015/prateek-small.webp', percentage: 'CAT 100%ile', alt: 'OMET Toppers' },
        { img: 'https://media.iquanta.in/ui_images/cat2015/sabyasachi1.webp', percentage: 'CAT 100%ile', alt: 'OMET Toppers' },
        { img: 'https://media.iquanta.in/ui_images/cat2017/aabhas1.webp', percentage: 'CAT 99.85%ile', alt: 'OMET Toppers' },
        { img: 'https://media.iquanta.in/ui_images/cat2017/shikhar1.webp', percentage: 'CAT 99.98%ile', alt: 'OMET Toppers' },
        { img: 'https://media.iquanta.in/ui_images/cat2016/dhruv1.webp', percentage: 'CAT 99.98%ile', alt: 'OMET Toppers' },
        { img: 'https://media.iquanta.in/ui_images/cat2018/mihir1.webp', percentage: 'CAT 99.97%ile', alt: 'OMET Toppers' },
        { img: 'https://media.iquanta.in/ui_images/kislay-small.webp', percentage: 'CAT 99.96%ile', alt: 'OMET Toppers' },
        { img: 'https://media.iquanta.in/ui_images/Shivam-Kumar-small.webp', percentage: 'CAT 99.95%ile', alt: 'OMET Toppers' },
        { img: 'https://media.iquanta.in/ui_images/rahul-small.webp', percentage: 'CAT 99.94%ile', alt: 'OMET Toppers' },
        { img: 'https://media.iquanta.in/ui_images/Ankit-Raj-small.webp', percentage: 'CAT 99.96%ile', alt: 'OMET Toppers' },

      ], link: '/results'
    },

    '2': {
      header: '700+ 99%ilers & 1000s of CAT Toppers', para: '25,000 IIM calls in just 5 years', bgimg: 'https://media.iquanta.in/ui_images/result-bg-menu.svg',
      alt: 'OMET Toppers', toppersImgs: [
        { img: 'https://media.iquanta.in/ui_images/cat2019/rishi1.webp', percentage: 'CAT 100%ile', alt: 'OMET Toppers' },
        { img: 'https://media.iquanta.in/ui_images/cat2017/gaurav1.webp', percentage: 'CAT 99.90%ile', alt: 'OMET Toppers' },
        { img: 'https://media.iquanta.in/ui_images/cat2015/prateek-small.webp', percentage: 'CAT 100%ile', alt: 'OMET Toppers' },
        { img: 'https://media.iquanta.in/ui_images/cat2015/sabyasachi1.webp', percentage: 'CAT 100%ile', alt: 'OMET Toppers' },
        { img: 'https://media.iquanta.in/ui_images/cat2017/aabhas1.webp', percentage: 'CAT 99.85%ile', alt: 'OMET Toppers' },
        { img: 'https://media.iquanta.in/ui_images/cat2017/shikhar1.webp', percentage: 'CAT 99.98%ile', alt: 'OMET Toppers' },
        { img: 'https://media.iquanta.in/ui_images/cat2016/dhruv1.webp', percentage: 'CAT 99.98%ile', alt: 'OMET Toppers' },
        { img: 'https://media.iquanta.in/ui_images/cat2018/mihir1.webp', percentage: 'CAT 99.97%ile', alt: 'OMET Toppers' },
        { img: 'https://media.iquanta.in/ui_images/kislay-small.webp', percentage: 'CAT 99.96%ile', alt: 'OMET Toppers' },
        { img: 'https://media.iquanta.in/ui_images/Shivam-Kumar-small.webp', percentage: 'CAT 99.95%ile', alt: 'OMET Toppers' },
        { img: 'https://media.iquanta.in/ui_images/rahul-small.webp', percentage: 'CAT 99.94%ile', alt: 'OMET Toppers' },
        { img: 'https://media.iquanta.in/ui_images/Ankit-Raj-small.webp', percentage: 'CAT 99.96%ile', alt: 'OMET Toppers' },

      ], link: '/results'
    },
    '3': {
      header: '60+ Cracked', para: 'IPMAT IIM Indore & Rohtak', bgimg: 'https://media.iquanta.in/ui_images/percentile-result.webp',
      alt: 'CUET Toppers', toppersImgs: [
        { img: 'https://media.iquanta.in/ui_images/cuet/cuet-t-1.jpg', percentage: '', alt: 'CUET Toppers' },
        { img: 'https://media.iquanta.in/ui_images/cuet/cuet-t-2.jpg', percentage: '', alt: 'CUET Toppers' },
        { img: 'https://media.iquanta.in/ui_images/cuet/cuet-t-3.jpg', percentage: '', alt: 'CUET Toppers' },
        { img: 'https://media.iquanta.in/ui_images/cuet/cuet-t-4.jpg', percentage: '', alt: 'CUET Toppers' },
        { img: 'https://media.iquanta.in/ui_images/cuet/cuet-t-5.jpg', percentage: '', alt: 'CUET Toppers' },
        { img: 'https://media.iquanta.in/ui_images/cuet/cuet-t-6.jpg', percentage: '', alt: 'CUET Toppers' },
        { img: 'https://media.iquanta.in/ui_images/cuet/cuet-t-7.jpg', percentage: '', alt: 'CUET Toppers' },
        { img: 'https://media.iquanta.in/ui_images/cuet/cuet-t-8.jpg', percentage: '', alt: 'CUET Toppers' },
        { img: 'https://media.iquanta.in/ui_images/cuet/cuet-t-9.jpg', percentage: '', alt: 'CUET Toppers' },
        { img: 'https://media.iquanta.in/ui_images/cuet/cuet-t-10.jpg', percentage: '', alt: 'CUET Toppers' },
        {},
        {}

      ], link: '/ipmat-results'
    },
    '4': {
      header: '200+ 100 Percentilers in', para: 'CUET UG 2022 & 2023', bgimg: 'https://media.iquanta.in/ui_images/percentile-result.webp',
      alt: 'CUET Toppers', toppersImgs: [
        { img: 'https://media.iquanta.in/ui_images/cuet/cuet-t-1.jpg', percentage: '', alt: 'CUET Toppers' },
        { img: 'https://media.iquanta.in/ui_images/cuet/cuet-t-2.jpg', percentage: '', alt: 'CUET Toppers' },
        { img: 'https://media.iquanta.in/ui_images/cuet/cuet-t-3.jpg', percentage: '', alt: 'CUET Toppers' },
        { img: 'https://media.iquanta.in/ui_images/cuet/cuet-t-4.jpg', percentage: '', alt: 'CUET Toppers' },
        { img: 'https://media.iquanta.in/ui_images/cuet/cuet-t-5.jpg', percentage: '', alt: 'CUET Toppers' },
        { img: 'https://media.iquanta.in/ui_images/cuet/cuet-t-6.jpg', percentage: '', alt: 'CUET Toppers' },
        { img: 'https://media.iquanta.in/ui_images/cuet/cuet-t-7.jpg', percentage: '', alt: 'CUET Toppers' },
        { img: 'https://media.iquanta.in/ui_images/cuet/cuet-t-8.jpg', percentage: '', alt: 'CUET Toppers' },
        { img: 'https://media.iquanta.in/ui_images/cuet/cuet-t-9.jpg', percentage: '', alt: 'CUET Toppers' },
        { img: 'https://media.iquanta.in/ui_images/cuet/cuet-t-10.jpg', percentage: '', alt: 'CUET Toppers' },
{},
        {}
      ], link: '/cuet-results'
    },
    '5': {
      header: '200+ 100 Percentilers in', para: 'CUET UG 2022 & 2023', bgimg: 'https://media.iquanta.in/ui_images/percentile-result.webp',
      alt: 'CUET Toppers', toppersImgs: [
        { img: 'https://media.iquanta.in/ui_images/cuet/cuet-t-1.jpg', percentage: '', alt: 'CUET Toppers' },
        { img: 'https://media.iquanta.in/ui_images/cuet/cuet-t-2.jpg', percentage: '', alt: 'CUET Toppers' },
        { img: 'https://media.iquanta.in/ui_images/cuet/cuet-t-3.jpg', percentage: '', alt: 'CUET Toppers' },
        { img: 'https://media.iquanta.in/ui_images/cuet/cuet-t-4.jpg', percentage: '', alt: 'CUET Toppers' },
        { img: 'https://media.iquanta.in/ui_images/cuet/cuet-t-5.jpg', percentage: '', alt: 'CUET Toppers' },
        { img: 'https://media.iquanta.in/ui_images/cuet/cuet-t-6.jpg', percentage: '', alt: 'CUET Toppers' },
        { img: 'https://media.iquanta.in/ui_images/cuet/cuet-t-7.jpg', percentage: '', alt: 'CUET Toppers' },
        { img: 'https://media.iquanta.in/ui_images/cuet/cuet-t-8.jpg', percentage: '', alt: 'CUET Toppers' },
        { img: 'https://media.iquanta.in/ui_images/cuet/cuet-t-9.jpg', percentage: '', alt: 'CUET Toppers' },
        { img: 'https://media.iquanta.in/ui_images/cuet/cuet-t-10.jpg', percentage: '', alt: 'CUET Toppers' },
{},
        {}
      ], link: '/cuet-results'
    },
    '6': {
      header: '3,000+ Toppers in', para: 'NEET 2024', bgimg: 'https://media.iquanta.in/ui_images/neet/percentile-result-neet-new.webp',
      alt: 'NEET Toppers', toppersImgs: [
        { img: 'https://media.iquanta.in/ui_images/neet/neet-result-1.webp', percentage: '', alt: 'NEET Toppers' },
        { img: 'https://media.iquanta.in/ui_images/neet/neet-result-2.webp', percentage: '', alt: 'NEET Toppers' },
        { img: 'https://media.iquanta.in/ui_images/neet/neet-result-3.webp', percentage: '', alt: 'NEET Toppers' },
        { img: 'https://media.iquanta.in/ui_images/neet/neet-result-4.webp', percentage: '', alt: 'NEET Toppers' },
        { img: 'https://media.iquanta.in/ui_images/neet/neet-result-5.webp', percentage: '', alt: 'NEET Toppers' },
        { img: 'https://media.iquanta.in/ui_images/neet/neet-result-6.webp', percentage: '', alt: 'NEET Toppers' },
        { img: 'https://media.iquanta.in/ui_images/neet/neet-result-07.png', percentage: '', alt: 'NEET Toppers' },
        { img: 'https://media.iquanta.in/ui_images/neet/neet-result-08.png', percentage: '', alt: 'NEET Toppers' },
        { img: 'https://media.iquanta.in/ui_images/neet/neet-result-09.png', percentage: '', alt: 'NEET Toppers' },
        { img: 'https://media.iquanta.in/ui_images/iit-jee/SHIVANGI-JAIN-(99.05).jpg', percentage: '', alt: 'NEET Toppers' },
        { img: 'https://media.iquanta.in/ui_images/iit-jee/OMKAR-NATH-SHUKLA-(99.29).jpg', percentage: '', alt: 'NEET Toppers' },
        { img: 'https://media.iquanta.in/ui_images/iit-jee/PUNYAM-SWARUP-PADHI-(99.17).jpg', percentage: '', alt: 'NEET Toppers' },


      ], link: ''
    },
    '7': {
      header: '273 Students Got 90+ %ile', para: 'IIT JEE 2024', bgimg: 'https://media.iquanta.in/ui_images/neet/percentile-result-neet-new.webp',
      alt: 'IIT-JEE Toppers', toppersImgs: [
        { img: 'https://media.iquanta.in/ui_images/iit-jee/HIMANSHU KASANA (99.68).jpg', percentage: '', alt: 'IIT JEE Toppers' },
        { img: 'https://media.iquanta.in/ui_images/iit-jee/nikhil-yadav-9955-6719f06ae4b60.webp', percentage: '', alt: 'IIT JEE Toppers' },
        { img: 'https://media.iquanta.in/ui_images/iit-jee/Kshitij bajpai 99.43.jpg', percentage: '', alt: 'IIT JEE Toppers' },
        { img: 'https://media.iquanta.in/ui_images/iit-jee/VEDANT VIJAY PATIL (99.29).jpg', percentage: '', alt: 'IIT JEE Toppers' },
        { img: 'https://media.iquanta.in/ui_images/iit-jee/OMKAR-NATH-SHUKLA-(99.29).jpg', percentage: '', alt: 'IIT JEE Toppers' },
        { img: 'https://media.iquanta.in/ui_images/iit-jee/SHAKSHAM PANDAY (99.22).jpg', percentage: '', alt: 'IIT JEE Toppers' },
        { img: 'https://media.iquanta.in/ui_images/iit-jee/SHREYANSH-PANDEY-(99.22).jpg', percentage: '', alt: 'IIT JEE Toppers' },
        { img: 'https://media.iquanta.in/ui_images/iit-jee/RAGHVENDRA-MISHRA-(99.18).jpg', percentage: '', alt: 'IIT JEE Toppers' },
        { img: 'https://media.iquanta.in/ui_images/iit-jee/PUNYAM-SWARUP-PADHI-(99.17).jpg', percentage: '', alt: 'IIT JEE Toppers' },
        { img: 'https://media.iquanta.in/ui_images/iit-jee/PRANAY-JAIN-(99.12).jpg', percentage: '', alt: 'IIT JEE Toppers' },
        { img: 'https://media.iquanta.in/ui_images/iit-jee/CHHITANSHU SHEKHAR (99.75).jpg', percentage: '', alt: 'IIT JEE Toppers' },
        { img: 'https://media.iquanta.in/ui_images/iit-jee/RAHUL-PRATAP-(99.0576839).jpg', percentage: '', alt: 'IIT JEE Toppers' },
      ], link: ''
    },

  }

  franchiselist: any[] = [
    { img: 'https://media.iquanta.in/ui_images/agra.webp', cityname: 'Agra', city: 'Uttar Pradesh', link: '/offline-center/agra' },
    { img: 'https://media.iquanta.in/ui_images/bhopal.webp', cityname: 'Bhopal', city: 'Madhya Pradesh', link: '/offline-center/bhopal' },
    { img: 'https://media.iquanta.in/ui_images/bhubaneswar.webp', cityname: 'Bhubaneswar', city: 'Odisha', link: '/offline-center/bhubaneswar' },
    { img: 'https://media.iquanta.in/ui_images/chandigarh.webp', cityname: 'Chandigarh', city: 'Chandigarh', link: '/offline-center/chandigarh' },
    { img: 'https://media.iquanta.in/ui_images/goa.webp', cityname: 'Goa', city: 'Goa', link: '/offline-center/goa' },
    { img: 'https://media.iquanta.in/ui_images/Indore.webp', cityname: 'Indore', city: 'Madhya Pradesh', link: '/offline-center/indore' },
    { img: 'https://media.iquanta.in/ui_images/jaipur.webp', cityname: 'Jaipur', city: 'Rajasthan', link: '/offline-center/jaipur' },
    { img: 'https://media.iquanta.in/ui_images/jammu.webp', cityname: 'Jammu', city: 'Jammu & Kashmir', link: '/offline-center/jammu' },
    { img: 'https://media.iquanta.in/ui_images/jamshedpur.webp', cityname: 'Jamshedpur', city: 'Jharkhand', link: '/offline-center/jamshedpur' },
    { img: 'https://media.iquanta.in/ui_images/kochi.webp', cityname: 'Kochi', city: 'Kerala', link: '/offline-center/kochi' },
    // { img: 'https://media.iquanta.in/ui_images/kolkata.jpg', cityname: 'Kolkata', city: 'West Bengal', link: '/offline-center/kolkata' },
    { img: 'https://media.iquanta.in/ui_images/luthiana.webp', cityname: 'Ludhiana', city: 'Punjab', link: '/offline-center/ludhiana' },

    { img: 'https://media.iquanta.in/ui_images/nagpur.webp', cityname: 'Nagpur', city: 'Maharashtra', link: '/offline-center/nagpur' },
    { img: 'https://media.iquanta.in/ui_images/noida.webp', cityname: 'Noida', city: 'Uttar Pradesh', link: '/offline-center/noida' },
   
    { img: 'https://media.iquanta.in/ui_images/patna.webp', cityname: 'Patna', city: 'Bihar', link: '/offline-center/patna' },
    { img: 'https://media.iquanta.in/ui_images/prayagraj.webp', cityname: 'Prayagraj', city: 'Uttar Pradesh', link: '/offline-center/prayagraj' },
    { img: 'https://media.iquanta.in/ui_images/raipur.webp', cityname: 'Raipur', city: 'Chhattisgarh', link: '/offline-center/raipur' },
    { img: 'https://media.iquanta.in/ui_images/rajkot.webp', cityname: 'Rajkot', city: 'Gujarat', link: '/offline-center/rajkot' },
    // { img: 'https://media.iquanta.in/ui_images/ranchi.jpg', cityname: 'Ranchi', city: 'Jharkhand', link: '/offline-center/ranchi' },
    // { img: 'https://media.iquanta.in/ui_images/srinagar.jpg', cityname: 'Srinagar', city: 'Jammu & Kashmir', link: '/offline-center/srinagar' },
    { img: 'https://media.iquanta.in/ui_images/surat.webp', cityname: 'Surat', city: 'Gujarat', link: '/offline-center/surat' },
    { img: 'https://media.iquanta.in/ui_images/siliguri.webp', cityname: 'Siliguri', city: 'West Bengal', link: '/offline-center/siliguri' },

    // { img: 'https://media.iquanta.in/ui_images/Varanasi.jpg', cityname: 'Varanasi', city: 'Uttar Pradesh', link: '/offline-center/varanasi' },
    //
    { img: 'https://media.iquanta.in/ui_images/vadodara.webp', cityname: 'Vadodara', city: 'Gujarat', link: '/offline-center/vadodara' },

    // { img: 'https://media.iquanta.in/ui_images/thane.jpg', cityname: 'Thane', city: 'Maharashtra', link: '/offline-center/thane' },
    // { img: 'https://media.iquanta.in/ui_images/lucknow.jpg', cityname: 'Lucknow', city: 'Uttar Pradesh', link: '/offline-center/lucknow' },
    // { img: 'https://media.iquanta.in/ui_images/jhansi.jpg', cityname: 'Jhansi', city: 'Uttar Pradesh', link: '/offline-center/jhansi' },
    // 
  ]

  token: any;
  notificationList: any[] = []
  @ViewChild('componentDiv', { static: true })
  componentDiv!: ElementRef;
  constructor(public courseService: HeaderService, public dashboardService: HeaderService,
    public snackBar: MatSnackBar, public dialog: MatDialog,
    @Inject(LOCAL_STORAGE) public sessionStorage: any,
    public authService: AuthService, public loginService: LoginService, private zone: NgZone, public router: Router,
    public deviceService: DeviceDetectorService, @Inject(DOCUMENT) public document: any, public renderer2: Renderer2
  ) {
  }

  isNumber(event: any) {
    var charCode = (event.which) ? event.which : event.keyCode;
    // Only Numbers 0-9
    if ((charCode < 48 || charCode > 57)) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }

  ngAfterViewInit() {
    this.megMenuJs()
  }

  iitjee() {
    this.dashboardService.saveDialog('open');
  }

  iitcourses() {
    this.dashboardService.saveCourseFlag('courses')
  }

  gotoresults() {
    this.courseService.saveResultScroll('scroll')
    this.router.navigate(['/iit-jee-coaching'])
  }

  displayMenuFlag: boolean = false;



  openwhatsup() {
    window.open('https://api.whatsapp.com/send/?phone=918130900243', '_blank')
  }


  public scrolling = false;
  private timeout: any;
  @HostListener('window:scroll', ['$event'])
  onWindowScroll(event: any) {
    const element = this.componentDiv.nativeElement;
    const viewportOffset = element.getBoundingClientRect();
    const list = document.getElementsByTagName("body")[0];
    const viewportOffset1 = list.getBoundingClientRect();
    const top1 = viewportOffset1.top;
    const top = viewportOffset.top;
    if (top1 < 0) {
      let div: any = document.getElementById('componentDiv')
      div.classList.add('sticky-menu')
    } else if (top == 0) {
      let div: any = document.getElementById('componentDiv')
      div.classList.remove('sticky-menu')
    }
    this.scrolling = true;
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.scrolling = false;
    }, 200);
  }

  download(val: any) {
    if (val == 'MBA') {
      window.open('https://media.iquanta.in/ui_images/MBA_BROCHURE.pdf', '_blank')
    } else {
      window.open('https://media.iquanta.in/cat-2025-strategy-syllabus.pdf', '_blank')
    }
  }



  getProfileData() {
    this.loginService.profileData.subscribe(res => {
      this.token = this.sessionStorage.getItem('usertoken');
      if (this.sessionStorage.getItem('userData')) {
        this.userData = JSON.parse(this.sessionStorage.getItem('userData'));

      } else {
        this.token = '';
        this.userData = ''
      }

    })

    this.authService.user.subscribe(reqObj => {
      if (reqObj) {
        let reqData = {
          id: reqObj.sub,
          username: reqObj.name.split(' ').join() + '-' + reqObj.sub,
          email: reqObj.email,
          gmail_pic: reqObj.picture
        }
        this.loginService.gmail_login(reqData).subscribe(res => {
          if (res.success) {
            this.userData = reqData;
            this.token = res.key;
            this.sessionStorage.setItem('usertoken', this.token);
            this.sessionStorage.setItem('userData', JSON.stringify(reqData));
            this.loginService.userProfile(this.userData)
          }
        })
      }
    })
  }

  logout() {

    this.zone.run(() => {
      this.sessionStorage.clear();
      this.saveLoginInfo(false);
      this.token = '';
      this.userData = '';
      this.ngOnInit();
      this.loginService.userProfile('')
      this.router.navigate(['/'])
      // this.socialAuthService.signOut()

      // this.cdr.detectChanges();

    });
  }

  predector() {
    this.router.navigate(['/iim-call-predictor'])
  }

  ipAddress: any;
  getAddressIP() {
    this.loginService.getIPAddress().subscribe((res: any) => {
      this.ipAddress = res.ip;
    });
  }

  saveLoginInfo(status: any) {
    let page = document.URL.split('/')[document.URL.split('/').length - 1]
    let reqObj = {
      ip_address: this.ipAddress,
      location: '',
      status: status,
      device: this.deviceService.isMobile() ? 'Mobile' : 'Desktop',
      page_location: page ? page : 'Home'
    }
    this.loginService.saveLoginInfo(reqObj, this.token).subscribe(res => {
      // location.reload()
    })
  }

  qa(val: any) {
    this.change.emit(val)
    this.router.navigate(['/test/' + val])
  }

  scrollTo1(val: any) {
    this.courseService.saveScroll(val)
    this.router.navigate(['/mba'])

  }

  downloadsheet1() {
    if (this.token) {
      window.open('https://media.iquanta.in/ui_images/ipmat-2.pdf', '_blank')
    } else {
      $("#PdfModal").modal('hide')
      this.login('Download IPMAT Syllabus & Strategy')
    }
  }

  goto() {
    // this.router.navigate(['/cat-2025'])
    // if(this.pageType == 'cat-2025'){
    var elemnt: any = document.getElementById('courses')
    elemnt.scrollIntoView({ behavior: "smooth" })
    // }
  }

  download1() {
    if (this.token) {
      if (this.pageType == 'ipmat') {
        window.open('https://media.iquanta.in/ui_images/ipmat-1.pdf', '_blank')
      } else {
        window.open('https://media.iquanta.in/ui_images/iQuanta+Quant+Formulae+eBook+.pdf', '_blank')
      }
    } else {
      $("#PdfModal").modal('hide')
      this.login('Download Formula Book')
    }
  }


  downloadsheet() {
    if (this.token) {
      window.open('https://media.iquanta.in/ui_images/VA-RC.pdf', '_blank')
    } else {
      $("#PdfModal").modal('hide')
      this.login('Download VARC Cheat Sheet')
    }
  }

  joinwhatsapp(val: any) {
    if (this.pageType == 'mba') {
      window.open('https://chat.whatsapp.com/KNz4FdzMlTTFPgbIckw78p', '_blank')
    } else if (this.pageType == 'cat-2025') {
      window.open('https://chat.whatsapp.com/BWMOByGwXtr1LPGoU5qBgm', '_blank')
    }else if(this.url == 'iim-abc'){
      window.open('https://chat.whatsapp.com/J9o1rnxFmAQ3CX87rjlzZR', '_blank')
    }
    else {
      window.open(val, '_blank')
    }
  }

  download2() {
    if (this.token) {
      window.open('https://media.iquanta.in/ui_images/PI+Transcript.pdf', '_blank')
    } else {
      $("#PdfModal").modal('hide')
      this.login('Download PI Transcript')
    }
  }

  getProfile() {
    this.dashboardService.getProfile(this.token).subscribe(res => {
      if (res.success) {
        this.userData = res.data[0];
        this.sessionStorage.setItem('userData', JSON.stringify(this.userData));
        this.sessionStorage.setItem('mockData', JSON.stringify(res.mock_login))
        this.loginService.userProfile(this.userData)
      }
    })
  }

  userData: any;

  login(type: any) {
    if(this.pageUrl){
      this.sessionStorage.setItem('pageUrl', this.pageUrl)
    }
    const dialogRef = this.dialog.open(LoginModal, {
      width: '750px',
      panelClass: 'login_modal',
      autoFocus: false,
      data: type
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == 'yes') {

      } else if (typeof (result) == 'object') {
        if (this.sessionStorage.getItem('usertoken')) {
          this.token = this.sessionStorage.getItem('usertoken');
          this.getProfile()
        } else {
          this.userData = result;
          this.token = this.sessionStorage.getItem('usertoken');;
          this.sessionStorage.setItem('userData', JSON.stringify(result));
          this.loginService.userProfile(this.userData)

        }
      }
    });
  }

  addCallClickData(type: any) {
    let reqObj = {
      "examName": type,
      "count": 1
    }
    this.dashboardService.addCallClickData(reqObj).subscribe((res: any) => {

    })
  }

  gotoLink(link: any) {
    window.open(link, '_blank')
  }

  pastPapersTabVal: any = '1'
  pastpaperstabchange(val: any) {
    this.pastPapersTabVal = val;
  }
  mocksTabVal: any = '1'
  mockstabchange(val: any) {
    this.mocksTabVal = val;
  }
  resulttabVal: any = '1'
  resulttabchange(val: any) {
    this.resulttabVal = val;
  }

  gotolink(val: any) {
    window.open(val, '_blank')
  }
  knowusTabVal: any = '1'
  knowustabchange(val: any) {
    this.knowusTabVal = val;
  }
  blogTabVal: any = '1'
  blogtabchange(val: any) {
    this.blogTabVal = val;
  }

  gotoBlog(val: any) {
    window.open(val, '_blank')
  }

  getNoti() {
    // this.sendEventToGTM()
    this.courseService.getAllFooterNotifications().subscribe(res => {
      if (res.success) {
        this.notificationList = res.data;
      }
    })
  }

  gotoProduct(val: any) {
    if (val) {
      this.changeCourse.emit(val)

    }
  }

  gotoFooter(selectedIndicator: any) {
    window.open(selectedIndicator.link, '_blank')
  }

  coursesMenuFlag:boolean = false;
  pastPapersMenuFlag:boolean = false;
  mocksMenuFlag:boolean = false;
  resultsMenuFlag:boolean = false;
  knowusMenuFlag: boolean = false;
  blogMenuFlag: boolean = false;
  offlineMenuFlag:boolean = false;

  displayCourses(){
    this.coursesMenuFlag = !this.coursesMenuFlag;
  }

  displayPastPapers(){
    this.pastPapersMenuFlag = !this.pastPapersMenuFlag;
  }

  displayMocks(){
    this.mocksMenuFlag = !this.mocksMenuFlag;
  }

  displayResults(){
    this.resultsMenuFlag = !this.resultsMenuFlag;
  }

  displayknowus(){
    this.knowusMenuFlag = !this.knowusMenuFlag;
  }

  displayBlog(){
    this.blogMenuFlag = !this.blogMenuFlag;
  }

  displayOffline(){
    this.offlineMenuFlag = !this.offlineMenuFlag;
  }

  megMenuJs() {

    if (this.deviceService.isMobile()) {
      const menu: any = document.querySelector(".menu");
      const menuMain = menu.querySelector(".menu-main");
      const goBack = menu.querySelector(".go-back");
      const menuTrigger: any = document.querySelector(".mobile-menu-trigger");
      const closeMenu = menu.querySelector(".mobile-menu-close");
      let subMenu: any;
      menuMain.addEventListener("click", (e: any) => {
        // console.log(e)
        if (!menu.classList.contains("active")) {
          return;
        }
        if (e.target.closest(".menu-item-has-children")) {
          const hasChildren = e.target.closest(".menu-item-has-children");
          showSubMenu(hasChildren);
        }
      });
      goBack.addEventListener("click", () => {
        hideSubMenu();
      })
      menuTrigger.addEventListener("click", () => {
        toggleMenu();
      })
      closeMenu.addEventListener("click", () => {
        toggleMenu();
      })
      let menuOverlay: any = document.querySelector(".menu-overlay")
      menuOverlay.addEventListener("click", () => {
        toggleMenu();
      })
      function toggleMenu() {
        menu.classList.toggle("active");
        menuOverlay.classList.toggle("active");
      }
      function showSubMenu(hasChildren: any) {
        subMenu = hasChildren.querySelector(".sub-menu");
        subMenu.classList.add("active");
        subMenu.style.animation = "slideLeft 0.5s ease forwards";
        const menuTitle = hasChildren.querySelector("i").parentNode.childNodes[0].textContent;
        menu.querySelector(".current-menu-title").innerHTML = menuTitle;
        menu.querySelector(".mobile-menu-head").classList.add("active");
      }

      function hideSubMenu() {
        subMenu.style.animation = "slideRight 0.5s ease forwards";
        setTimeout(() => {
          subMenu.classList.remove("active");
        }, 300);
        menu.querySelector(".current-menu-title").innerHTML = "";
        menu.querySelector(".mobile-menu-head").classList.remove("active");
      }

      window.onresize = function () {
        // if (this.innerWidth > 991) {
        //   if (menu.classList.contains("active")) {
        //     toggleMenu();
        //   }

        // }
      }

    }
  }

  gotoDashboard() {
    this.sessionStorage.setItem('pageUrl', this.document.URL)
  }
  imageObj:any;
  getImage() {
    this.loginService.getLoginImage().subscribe(res => {
      if (res.length > 0) {
        this.imageObj = res[0]
      }
    })
  }

  sendEventToGTM() {
    const s = this.renderer2.createElement('script');
    s.text = `window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({

  'event' : 'pageload',

  'userId' :  ${this.userData ? this.userData.id : '0'}

})`;
    this.renderer2.appendChild(this.document.body, s);
  }

  ngOnInit(): void {
    if (this.sessionStorage.getItem('usertoken')) {
      this.token = this.sessionStorage.getItem('usertoken');
      this.userData = JSON.parse(this.sessionStorage.getItem('userData'))
      if (!this.userData.referral_code) {
        this.snackBar.open('Session ended. Login again', 'OK', {
          verticalPosition: 'top',
          duration: 4000,
          panelClass: 'snack-success'
        })
        this.logout()
      }
    }
    this.getProfileData()
    this.getAddressIP()
    this.getNoti()



    if (this.pageType == 'xat' || this.pageType == 'nmat' || this.pageType == 'snap') {
      this.coursetabVal = '2';
      this.mocksTabVal = '2';
      this.pastPapersTabVal = '2';
      this.resulttabVal = '2';
    }

    if (this.pageType == 'gmat') {
      this.resulttabVal = '5';
      this.mocksTabVal = '1';
      this.coursetabVal = '6';
      this.pastPapersTabVal = '1'
    }

    if (this.pageType == 'ipmat') {
      this.resulttabVal = '3';
      this.mocksTabVal = '3';
      this.coursetabVal = '3';
      this.pastPapersTabVal = '3'
    }

    if (this.pageType == 'after12') {
      this.resulttabVal = '3';
      this.mocksTabVal = '3';
      this.coursetabVal = '3';
      this.pastPapersTabVal = '3'
    }

    if (this.pageType == 'cuet') {
      this.resulttabVal = '4';
      this.mocksTabVal = '4';
      this.coursetabVal = '4';
      this.pastPapersTabVal = '4'

    }

    if (this.pageType == 'clat') {
      this.mocksTabVal = '4';
      this.coursetabVal = '5';
      this.pastPapersTabVal = '4'

    }

    if (this.pageType == 'neet') {
      this.mocksTabVal = '6';
      this.coursetabVal = '8';
      this.pastPapersTabVal = '6'
      this.resulttabVal = '6';
      this.blogTabVal = '7'
    }
    if (this.pageType == 'cat-2025' || this.pageType == 'cat-2024' || this.pageType == 'cat-2026' || this.pageType.includes('xat') || this.pageType.includes('nmat') || this.pageType.includes('snap') || this.pageType.includes('cat')) {
      // this.gtmService.loadGTM('G-CRBPRZGNQS')
      // this.sendEventToGTM()
    }
  }

  gotocourses() {
    var elemnt: any = document.getElementById('course')
    elemnt.scrollIntoView({ behavior: "smooth" })
  }

  coursetabVal: any = '1'
  coursetabchange(val: any) {
    this.coursetabVal = val;
  }

}

